declare global {
  interface Window {
    tolt_data: any;
    tolt_referral: any;
  }
}

const asId = (value: unknown) => (typeof value === 'string' ? value : '');

// Sent with the signup form, because the link may be opened in a browser with no referral.
export const getToltReferral = () => {
  const partnerId = window.tolt_referral ? asId(window.tolt_data?.partner_id) : '';

  return partnerId
    ? { toltPartnerId: partnerId, toltClickId: asId(window.tolt_data?.click_id) }
    : {};
};
